export default {
      id: "units-groups-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.svg#units-groups",
      toString: function () {
        return this.url;
      }
    }